var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 11.32,
    height: 11.32,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 9.86 9.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0{fill:#e3d1ad}"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2422883404000"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M3.47 3.56A1.48 1.48 0 0 0 4.6 4.99a1.48 1.48 0 0 0 1.35-.38 1.36 1.36 0 0 0 .39-.7 1.45 1.45 0 0 0-.29-1.27l-.08-.09a1.44 1.44 0 0 0-.81-.43l-.18-.02h-.13c-.14.01-.27.04-.43.09l-.13.05a1.38 1.38 0 0 0-.64.61l-.06.12c-.07.15-.13.37-.13.59zm1.47.61a.6.6 0 0 1-.61-.61.6.6 0 0 1 .61-.61.6.6 0 0 1 .61.61.6.6 0 0 1-.61.61zM3.29 5.47v.06c0 .11.08.24.14.29.08.07.24.15.34.2a2.29 2.29 0 0 0 .57.2.8.8 0 0 1-.13.13l-.64.64-.06.06c-.15.17-.15.43.01.58.07.07.18.13.28.13h.06c.04 0 .07 0 .12-.02.1-.04.14-.08.22-.15l.25-.25.5-.5.31.31.07.06c.09.09.44.45.5.49.06.04.13.06.19.06h.07c.15-.01.28-.1.35-.25a.41.41 0 0 0-.02-.39c-.05-.08-.3-.32-.37-.39l-.25-.25-.26-.26.09-.02a.98.98 0 0 0 .25-.07l.3-.13c.15-.08.28-.14.36-.28.03-.05.04-.11.05-.16V5.5a.46.46 0 0 0-.13-.29.45.45 0 0 0-.3-.12c-.16 0-.25.09-.4.16l-.13.06c-.54.2-1.12.17-1.61-.12-.09-.05-.16-.1-.28-.1a.47.47 0 0 0-.17.04.16.16 0 0 0-.07.04.4.4 0 0 0-.19.33z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.14,
    y: 0.14,
    width: 9.58,
    height: 9.58,
    rx: 2.23,
    ry: 2.23,
    style: {
      fill: "none",
      stroke: "#e3d1ad",
      strokeWidth: 0.28,
      strokeMiterlimit: 22.9256
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.ef8a9871512e6474d7a362c823246d67.svg";
export { ForwardRef as ReactComponent };